import React from "react";
import { Button } from "@mui/material";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const ExportarPDF = ({ refContenido, nombreArchivo = "export", label = "Exportar a PDF" }) => {
  const handleExportPDF = async () => {
    const input = refContenido.current;
    if (!input) return;

    const canvas = await html2canvas(input, { scale: 2 });
    const pdf = new jsPDF("p", "mm", "a4");
    const margin = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const usableWidth = pageWidth - margin * 2;
    const usableHeight = pageHeight - margin * 2;
    const pageHeightPx = Math.floor((usableHeight * canvas.width) / usableWidth);
    const totalPages = Math.ceil(canvas.height / pageHeightPx);

    for (let pageIndex = 0; pageIndex < totalPages; pageIndex += 1) {
      const startY = pageIndex * pageHeightPx;
      const sliceHeight = Math.min(pageHeightPx, canvas.height - startY);
      const pageCanvas = document.createElement("canvas");
      const pageContext = pageCanvas.getContext("2d");

      pageCanvas.width = canvas.width;
      pageCanvas.height = sliceHeight;

      if (!pageContext) return;

      pageContext.drawImage(
        canvas,
        0,
        startY,
        canvas.width,
        sliceHeight,
        0,
        0,
        canvas.width,
        sliceHeight
      );

      if (pageIndex > 0) {
        pdf.addPage();
      }

      const imgData = pageCanvas.toDataURL("image/png");
      const imgHeight = (sliceHeight * usableWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", margin, margin, usableWidth, imgHeight);
    }

    pdf.save(`${nombreArchivo}.pdf`);
  };

  return (
    <Button variant="contained" color="primary" onClick={handleExportPDF}>
      {label}
    </Button>
  );
};

export default ExportarPDF;
